/*
 * usePanel.ts - Provide FluentUI Panel Simulation in MUI
 *
 * Created by Dr. Maximillian Dornseif 2023-06-19 in huWaWi3 32.2.0
 * Copyright (c) 2023 HUDORA GmbH / Maximillian Dornseif
 */

import { DialogContent, IconButton, makeStyles } from '@fluentui/react'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContentText, DialogTitle } from '@mui/material'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import camelCase from 'lodash.camelcase'
import { useCallback, useState } from 'react'
import { BooleanParam, useQueryParam } from 'use-query-params'

/**
 *
 * @deprecated Use useHdDialog instead
 */
export function usePanelMui(title: string): [() => void, object, boolean, () => void] {
  const [isPanelOpenSP, setIsPanelOpenSP] = useQueryParam(camelCase(`${title}Panel`), BooleanParam)
  const [isPanelOpen, setIsPanelOpen] = useState(isPanelOpenSP)
  const openPanel = useCallback(() => {
    setIsPanelOpen(true)
    setIsPanelOpenSP(true)
  }, [setIsPanelOpen, setIsPanelOpenSP])
  const dismissPanel = useCallback(() => {
    setIsPanelOpen(false)
    setIsPanelOpenSP(undefined)
  }, [setIsPanelOpen, setIsPanelOpenSP])

  const panelProps = {
    open: isPanelOpen,
    onClose: dismissPanel,
    maxWidth: 'lg',
    fullWidth: false,
    scroll: 'paper',
    // ModalProps
    // PaperProps
    // closeButtonAriaLabel: `${title} Panel schließen`,
    // isFooterAtBottom: true, // make css:100% work within the Panel
    // layerProps: { styles: { root: { zIndex: 999 }}}
    // aria-labelledby aria-describedby
  }

  return [openPanel, panelProps, !!isPanelOpen, dismissPanel]
}

const useStyles = makeStyles((theme) => ({
  paper: {
    overflowY: 'unset',
  },
  customizedButton: {
    position: 'absolute',
    left: '95%',
    top: '1em',
    color: 'gray',
  },
}))

export function MuiPanel(props) {
  const classes = useStyles()
  return (
    <Dialog {...props}>
      <Box
        sx={{
          width: '50vw',
        }}
      >
        <DialogTitle id="alert-dialog-title">{props.headerText}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
          {props.children}
        </DialogContent>
        <DialogActions>
          <IconButton className={classes.customizedButton} onClick={() => props.onClose()}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Box>
    </Dialog>
  )
}
